import useAuth from '../../hooks/useAuth';

const ProjectSelector = ({ projects, selectedProjectId, onChange }) => {
  const { user } = useAuth();
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);
  if (!roleNames.has('admin') && !user?.superuser) {
    return <p>У вас нет прав для управления аналитикой.</p>;
  }
  console.log(projects)
  return (
    <div className="mb-4">
      <label htmlFor="project-selector" className="form-label">
        Выберите проект:
      </label>
      <select
        id="project-selector"
        className="form-select"
        value={selectedProjectId || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        required
      >
        <option value="">-- Выберите проект --</option>
        {projects.length === 0 ? (
          <option disabled>Нет доступных проектов</option>
        ) : (
          projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name_text || project.name}
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default ProjectSelector;



